// extracted by mini-css-extract-plugin
export var label = "_dj-2";
export var slideContainer = "_dj-0";
export var slider = "_dj-1";